import { ManagerPolygonalHotspot } from './ManagerPolygonalHotspot';
import { IndicatorRenderer } from './renderers/IndicatorRenderer';
import { ArrowPosition } from '@ael/core-api';
import { PanoramaRenderApi } from '@ael/core-api';

export class ManagerPolygonalHotspotWithIndicator extends ManagerPolygonalHotspot {
  private _indicatorRenderer: IndicatorRenderer;

  constructor(
    name: string,
    points: ArrowPosition[],
    indicatorPosition: number,
    indicatorScale: number,
    onClick?: () => void
  ) {
    super(name, points, onClick);
    this._name = name;
    this._indicatorRenderer = new IndicatorRenderer(
      name + '-indicator',
      points,
      indicatorPosition,
      indicatorScale,
      onClick
    );
  }

  render(pano: PanoramaRenderApi): void {
    super.render(pano);
    this._indicatorRenderer.render(pano);
  }
}
